import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import {
  Paper
} from "@mui/material";
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import { styled } from "@mui/material/styles";
import React from 'react';


const ExpandMore = styled((props) => {
    const { expand, ...other } = props;
    return <IconButton {...other} />;
  })(({ theme, expand }) => ({
    transform: !expand ? "rotate(0deg)" : "rotate(180deg)",
    marginLeft: "auto",
    transition: theme.transitions.create("transform", {
      duration: theme.transitions.duration.shortest,
    }),
  }));


const Accordian = ({children, title, headerBgColor, titleColor }) => {
    
    const [expanded, setExpanded] = React.useState(true);

    const handleExpandClick = () => {
        setExpanded(!expanded);
      };
    return (
        <>
      <Paper sx={{ my: 4 }}>
        <Card  sx={{ maxWidth: 1, boxShadow: 16,borderRadius: 2}}>
        <CardHeader
        sx={{  bgcolor:headerBgColor, color:titleColor }}
          action={
            <>
              <IconButton aria-label="settings">
                <MoreVertIcon />
              </IconButton>
              <ExpandMore
                expand={expanded}
                onClick={handleExpandClick}
                aria-expanded={expanded}
                aria-label="show more"
              >
                <ExpandMoreIcon />
              </ExpandMore>
            </>
          }
          title={title}
          subheader=" "
        />
        <Collapse in={expanded} timeout="auto"  sx={{ pl:2, pr:2, pt:2, pb:3}}>
        {children}
        </Collapse>
            </Card>
      </Paper>
    </>
    );
};

export default Accordian;
// unmountOnExit